import React, { Component } from "react";
// import WhatsAppIcon from "@material-ui/icons/WhatsApp";
// import InstagramIcon from "@material-ui/icons/Instagram";
// import TwitterIcon from '@mui/icons-material/Twitter';
// import PhoneIcon from "@material-ui/icons/Phone";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import { ReactComponent as Globe } from "./domain.svg";
// import { ReactComponent as WhatsApp } from "./whatsapp.svg";
import { ReactComponent as Email } from "./mail.svg";
import { ReactComponent as CustomerService } from "./customer-service.svg";
import { ReactComponent as Phone } from "./phone.svg";
import InstagramIcon from "./assests/instagram.png";
import SnapchatIcon from "./assests/snapchat.png";
import TiktokIcon from "./assests/tiktok.png";
import TwitterIcon from "./assests/twitter.png";
import FacebookIcon from "./assests/facebook.png";
import WhatsappIcon from "./assests/whatsapp.png";
import "../AreaSelect/style.css";

class Connect extends Component {
  render() {
    const language = this.props.language;
    const settings = this.props.settings;

    let email = settings.contact_email || "";
    return (
      <div style={{ marginTop: 30 }}>
        <p
          className="box-title"
          style={{ textAlign: language === "arabic" ? "right" : "left" }}
        >
          {language == "arabic" ? "تواصل معنا" : "Connect with us"}
        </p>
        <div
          className="w-100 text-center pb-2 bordered"
          style={{
            height: 80,
            backgroundColor: "white",
            borderWidth: 1,
          }}
        >
          <div
            className="row justify-content-start row-reverse"
            style={{
              padding: "0px 10px",
              height: "100%",
              alignItems: "center",
            }}
          >
            {settings.link_whatsapp && (
              <div
                className={"col p-0 ".concat(
                  language == "english" ? "order-1" : "order-3"
                )}
              >
                <a
                  href={`https://api.whatsapp.com/send?phone=${settings.link_whatsapp}`}
                >
                  <IconButton className="p-0">
                    <img
                      src={WhatsappIcon}
                      style={{ height: 32.36, width: 32.36 }}
                    />
                  </IconButton>
                </a>
              </div>
            )}
            {settings.link_instagram && (
              <div className="col p-0 order-2">
                <a href={settings.link_instagram}>
                  <IconButton className="p-0">
                    <img
                      src={InstagramIcon}
                      style={{ height: 32.36, width: 32.36 }}
                    />
                  </IconButton>
                </a>
              </div>
            )}
            {settings.link_snapchat && (
              <div className="col p-0 order-2">
                <a href={settings.link_snapchat}>
                  <IconButton className="p-0">
                    <img
                      src={SnapchatIcon}
                      style={{ height: 32.36, width: 32.36 }}
                    />
                  </IconButton>
                </a>
              </div>
            )}
            {settings.link_twitter && (
              <div className="col p-0 order-2">
                <a href={settings.link_twitter}>
                  <IconButton className="p-0">
                    <img
                      src={TwitterIcon}
                      style={{ height: 32.36, width: 32.36 }}
                    />
                  </IconButton>
                </a>
              </div>
            )}
            {settings.link_facebook && (
              <div className="col p-0 order-2">
                <a href={settings.link_facebook} target="_blank">
                  <IconButton className="p-0">
                    <img
                      src={FacebookIcon}
                      style={{ height: 32.36, width: 32.36 }}
                    />
                  </IconButton>
                </a>
              </div>
            )}
            {settings.link_tiktok && (
              <div className="col p-0 order-2">
                <a href={settings.link_tiktok}>
                  <IconButton className="p-0">
                    <img
                      src={TiktokIcon}
                      style={{ height: 32.36, width: 32.36 }}
                    />
                  </IconButton>
                </a>
              </div>
            )}

            {settings.link_site && (
              <div className="col p-0 order-2">
                <a href={settings.link_site}>
                  <IconButton className="p-0">
                    <Globe style={{ height: 32.36, width: 32.36 }} />
                  </IconButton>
                </a>
              </div>
            )}
            {settings.link_phone && (
              <div
                className={"col p-0 ".concat(
                  language == "english" ? "order-3" : "order-1"
                )}
              >
                <a href={`tel:${settings.link_phone}`}>
                  <IconButton className="p-0">
                    <Phone style={{ height: 32.36, width: 32.36 }} />
                  </IconButton>
                </a>
              </div>
            )}

            {!!(settings.link_call_center || "").trim() && (
              <div
                className={"col p-0 ".concat(
                  language == "english" ? "order-3" : "order-1"
                )}
              >
                <a href={`tel:${settings.link_call_center}`}>
                  <IconButton className="p-0">
                    <CustomerService style={{ height: 32.36, width: 32.36 }} />
                  </IconButton>
                </a>
              </div>
            )}

            {email.trim() && (
              <div
                className={"col p-0 ".concat(
                  language == "english" ? "order-3" : "order-1"
                )}
              >
                <a href={`mailto:${email.trim()}`}>
                  <IconButton className="p-0">
                    <Email style={{ height: 28.36, width: 28.36 }} />
                  </IconButton>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    language: state.store.language,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(Connect);
